import * as Yup from "yup";

let LoginFormValidation = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

const productFormValidation = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  category: Yup.string().required("Category is required"),
  code: Yup.string().required("Code is required"),
  weight: Yup.string().required("Weight is required"),
  purity: Yup.string().required("Purity is required"),
});
const customerFormValidation = Yup.object().shape({
  customer: Yup.string(),
  title: Yup.string().required("Title is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      "Email is not valid"
    ),
  address: Yup.string().required("Address is required"),
  contact_number: Yup.string().required("Phone is required"),
});

const invoiceCustomerFormValidation = Yup.object().shape({
  customer: Yup.string().nullable(),
  customer_name: Yup.string().required("Customer name is required"),
  customer_email: Yup.string()
    .required("Email is required")
    .email("Email is not valid"),
  terms_of_delivery: Yup.string().nullable(),
  customer_contact_number: Yup.string()
    .required("Contact number is required")
    .matches(/^\+?[0-9]{7,15}$/, "Contact number must be valid"),
  customer_address: Yup.string().required("Address is required"),
  toc: Yup.string().required("Terms & Condition is required"),
  sub_total: Yup.string().required(),
  total_gst: Yup.string().required(),
  discount: Yup.string().required(),
  discount_type: Yup.string().required(),
  discount_amount: Yup.string().required(),
  grand_total: Yup.string().required(),

  order_items: Yup.array()
    .of(
      Yup.object().shape({
        code: Yup.string(),
        product: Yup.string(),
        title: Yup.string(),
        purity: Yup.string(),
        rate: Yup.string(),
        weight: Yup.string(),
        wastage: Yup.string(),
        cut_piece: Yup.string(),
        total_weight: Yup.string(),
        wage: Yup.string(),
        pote_stone: Yup.string(),
        grand_total: Yup.string(),
      })
    )
    .min(1, "At least one product is required")
    .required("Order items are required"),
});
const categoryFormValidation = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  code: Yup.string().required("Code is required"),
});
const reconcileStockFormValidation = Yup.object().shape({
  product: Yup.string().required("Product is required"),
  quantity: Yup.string().required("Quantity is required"),
  description: Yup.string().required("Description is required"),
});

const purchaseStockFormValidation = Yup.object().shape({
  orderNumber: Yup.string().required("Purchase order number is required"),
  quantity: Yup.string().required("Quantity is required"),
  weight: Yup.string().required("Description is required"),
  costPrice: Yup.string().required("Cost Price is required"),
});
const cutPieceFormValidation = Yup.object().shape({
  piece: Yup.string().required("Product is required"),
});
const cashOutFormValidation = Yup.object().shape({
  debit: Yup.string().required("Amount is required").min(1),
  note: Yup.string().required("Note is required"),
});

export {
  LoginFormValidation,
  productFormValidation,
  categoryFormValidation,
  customerFormValidation,
  reconcileStockFormValidation,
  cutPieceFormValidation,
  cashOutFormValidation,
  purchaseStockFormValidation,
  invoiceCustomerFormValidation
};
